// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"563ea4ce","455":"36c4d22b","977":"947f3d8e"}[chunkId] + ".chunk.js";
};